import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Col } from 'react-bootstrap'
import DatePicker from '../../../../LaridaeApp/datepicker/container/DatePicker'
import { actualizarDatosParaMuiTable } from './actions/TablaRegistroActividadBarreraBrutoActions'
import TablaRegistroActividadBarreraBrutoView from './components/TablaRegistroActividadBarreraBrutoView'

function TablaRegistroActividadBarreraBruto (props) {
  const { actualizarDatosParaMuiTable } = props

  useEffect(() => {
    actualizarDatosParaMuiTable(new Date(), new Date())
  }, [actualizarDatosParaMuiTable])

  const actualizarfechas = (fechaD, fechaH) => {
    actualizarDatosParaMuiTable(fechaD, fechaH)
  }

  return (
    <>
      <Col md={4} style={{ margin: '12px auto' }}>
        <DatePicker
          style={{ width: '95%' }}
          disabledFuture
          selectRange
          locale='es'
          onDateChange={actualizarfechas}
          titulo='Seleccione las fechas'
        />
      </Col>

      <TablaRegistroActividadBarreraBrutoView />
    </>

  )
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaRegistroActividadBarreraBruto)
